import axios, {AxiosResponse} from 'axios'
import {ApiResponse} from '../../../shared/models/ApiModels'
import {IPublicJobModel} from '../hr/job/JobModel'
import {IPublicCompanyModel} from './PublicModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

/**
 * Public sayfalar için interceptor'sız instance: oturum açmamış ziyaretçide token eklenmez,
 * 401'de login'e yönlendirme yapılmaz.
 */
const publicApi = axios.create()

/** Gateway, CV yükleme ve başvuruda Cloudflare Turnstile token'ını bu header'dan okur */
const captchaHeaders = (captchaToken?: string | null) =>
  captchaToken ? {'X-Captcha-Token': captchaToken} : {}

export interface IApplyAnswer {
  questionId: string
  value: string
}

export interface IApplyRequest {
  jobId: string
  firstname: string
  lastname: string
  email: string
  phone: string
  candidateLocation: string
  documentId: string
  consentTerms: boolean
  consentPrivacy: boolean
  consentFutureContact: boolean
  questions: IApplyAnswer[]
}

export function getPublicCompanyBySlug(
  slug: string
): Promise<AxiosResponse<ApiResponse<IPublicCompanyModel>>> {
  return publicApi.get(`${API_URL}api/v1/corporate/public/getBySlug/${encodeURIComponent(slug)}`)
}

export function getPublicCompanyById(
  corporateId: string
): Promise<AxiosResponse<ApiResponse<IPublicCompanyModel>>> {
  return publicApi.get(`${API_URL}api/v1/corporate/public/getById/${encodeURIComponent(corporateId)}`)
}

export function getPublicJob(jobId: string): Promise<AxiosResponse<ApiResponse<IPublicJobModel>>> {
  return publicApi.get(`${API_URL}api/v1/job/public/getById/${encodeURIComponent(jobId)}`)
}

export function getPublicJobsOfCompany(
  corporateId: string
): Promise<AxiosResponse<ApiResponse<IPublicJobModel[]>>> {
  return publicApi.get(
    `${API_URL}api/v1/job/public/getAllByCorporateId/${encodeURIComponent(corporateId)}`
  )
}

export function uploadCv(
  jobId: string,
  file: File,
  captchaToken?: string | null
): Promise<AxiosResponse<ApiResponse<{id: string}>>> {
  const formData = new FormData()
  formData.append('jobId', jobId)
  formData.append('file', file)
  return publicApi.post(`${API_URL}api/v1/document/public/upload-cv`, formData, {
    headers: captchaHeaders(captchaToken),
  })
}

export function applyJob(
  request: IApplyRequest,
  captchaToken?: string | null
): Promise<AxiosResponse<ApiResponse<void>>> {
  return publicApi.post(`${API_URL}api/v1/apply-job/public/create`, request, {
    headers: captchaHeaders(captchaToken),
  })
}
